/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveProjectFromLaborCostRequest } from '../../models/remove-project-from-labor-cost-request';

export interface RemoveProjectFromLaborCost$Params {
  id: string;
      body: RemoveProjectFromLaborCostRequest
}

export function removeProjectFromLaborCost(http: HttpClient, rootUrl: string, params: RemoveProjectFromLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeProjectFromLaborCost.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeProjectFromLaborCost.PATH = '/v0/laborCosts/{id}/remove-project';
